export const safeWindowOpen = (url: string) => {
  return window.open(url, '_blank', 'noopener');
};
